export function mySlideToggle(elm) {
	if (!elm.classList.contains('active')) {
		elm.classList.add('active');
		elm.style.height = 'auto';
		var height = elm.clientHeight + 'px';
		elm.style.height = '0px';
		setTimeout(function () {
			elm.style.height = height;
		}, 0);
	} else {
		elm.style.height = '0px';
		elm.addEventListener('transitionend', function () {
			elm.classList.remove('active');
		}, {
			once: true
		});
	}
}